module.exports = __webpack_public_path__ + "static/to-go-73a70a5321c3d9c6fdd98b31ecc54e59.jpg";